<div class="admin-rent">

  <h3>Mes locations</h3>

  @if (((myRentCars$  | async) !== undefined )) {
    <div class="car-list">
      @for (car of myRentCars; track car; let i = $index) {
        <div id="{{car.carId}}" class="car-section">
          <app-car-card-account
            [car]="car"
            [businessLine]="businessLine"
            [carImagesFolder]="(carImagesFolders$ | async)!.get(car.carId)!">
          </app-car-card-account>
          <app-bookings
            [objectSource]="objectSource"
            [offerId]="car.offerId">
          </app-bookings>
        </div>
      }
    </div>
  }

</div>
